<template>
    <div>
        <el-dialog :title="title" width="35%" :visible.sync="dialogVisible" :close-on-click-modal="false" @close='hideDialog'>
            <el-form :inline="true" :model="filters" label-width="70px" style="text-align:center" size="mini"  :rules="dataRule">
                <el-form-item label="批次" prop="importBatch">
                    <el-select v-model="filters.importBatch" style="width:300px" placeholder="请选择要删除的批次">
                        <el-option
                            v-for="item in batchList"
                            :key="item+1"
                            :label="item"
                            :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="主键列表" prop="dataIdStr">
                    <el-input
                        style="width:300px"
                        type="textarea"
                        :rows="4"
                        placeholder="可输入多行主键，回车换行分割"
                        v-model="filters.dataIdStr">
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button
                        icon="el-icon-delete"
                        type="danger"
                        @click="queryDelete"
                    >
                        批量删除
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
import PermButton from '@/components//Component/PermButton/Index'

export default {
    name: 'exportIndex',
    components: {
        PermButton
    },
    props: {
        title: {
            type: String,
            default: '导出'
        },
        exportType: {
            type: Number,
            default: 1
        },
        isProvince: {
            type: Boolean,
            default: false
        },
        isXKInfo: {
            type: Boolean,
            default: false
        },
        isXKExamPlace: {
            type: Boolean,
            default: false
        },
        isTouDang: {
            type: Boolean,
            default: false
        },
        isZhaoLu: {
            type: Boolean,
            default: false
        },
        isProfRemark: {
            type: Boolean,
            default: false
        },
        isProfInfo: {
            type: Boolean,
            default: false
        },
        isOnLineSchool: {
            type: Boolean,
            default: false
        },
        isTxExamType: {
            type: Boolean,
            default: false
        },
        isProfPredict: {
            type: Boolean,
            default: false
        },
        isSchoolPredict: {
            type: Boolean,
            default: false
        },
        isSegment: {
            type: Boolean,
            default: false
        },
        isProvinceBatch: {
            type: Boolean,
            default: false
        },
        isProvinceBatchLine: {
            type: Boolean,
            default: false
        },
        isProvinceScoreLine: {
            type: Boolean,
            default: false
        },
        isJointCate: {
            type: Boolean,
            default: false
        },
        isSchoolRank: {
            type: Boolean,
            default: false
        },
        isProvJoint: {
            type: Boolean,
            default: false
        },
        isProfLevel: {
            type: Boolean,
            default: false
        },
        isProfexam: {
            type: Boolean,
            default: false
        },
        isEnrollformula: {
            type: Boolean,
            default: false
        },
        isSmallscorelimit: {
            type: Boolean,
            default: false
        },
        isSameprof: {
            type: Boolean,
            default: false
        },
        tableId: {
            type: Number,
            default: 1
        },
        isSchTxExamType: {
            type: Boolean,
            default: false
        },
        isAdmissionSchoolType: {
            type: Boolean,
            default: false
        },
        isCollectionSchoolType: {
            type: Boolean,
            default: false
        },
        isProvinceScheduleType: {
            type: Boolean,
            default: false
        },
        isExamScheduleType: {
            type: Boolean,
            default: false
        },
        isBatchScheduleType: {
            type: Boolean,
            default: false
        },
        isExceptions: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            filters: {
                importBatch: null,
                dataIdStr: null
            },
            dataRule: {
                // importBatch:[{required:true, message:'删除批次不能为空', trigger:'blur'}]
            },
            dialogVisible: true,
            batchList: []
        }
    },
    methods: {
        queryDelete() {
            if (!this.filters.importBatch && !this.filters.dataIdStr) {
                this.$message({ message: '请先输入删除条件', type: 'warning' })
                return
            }
            var data = {
                importBatch: null,
                dataIdStr: null
            }
            data = Object.assign(data, this.filters)
            if (this.isProvince) {
                var module = 'Provincetj'
                var method = 'queryDelProvinceData'
            } else if (this.isXKInfo) {
                module = 'Xkinfo'
                method = 'queryDelXKinfo'
            } else if (this.isXKExamPlace) {
                module = 'Examplaceinfo'
                method = 'queryDelEPInfo'
            } else if (this.isTouDang) {
                module = 'TDInfo'
                method = 'quertDelData'
            } else if (this.isZhaoLu) {
                module = 'ZlInfo'
                method = 'queryDelData'
            } else if (this.isProfRemark) {
                module = 'ProfRemark'
                method = 'queryDelProfRemark'
            } else if (this.isProfInfo) {
                module = 'ProfInfo'
                method = 'queryDelProfInfo'
            } else if (this.isOnLineSchool) {
                module = 'Onlinschool'
                method = 'queryDelOnLineSchool'
            } else if (this.isTxExamType) {
                module = 'TxExamType'
                method = 'queryDelTxExamType'
            } else if (this.isProfPredict) {
                module = 'ProfPredict'
                method = 'queryDelProfPredict'
            } else if (this.isSchoolPredict) {
                module = 'SchoolPredict'
                method = 'queryDelSchoolPredict'
            } else if (this.isSegment) {
                module = 'SegmentTable'
                method = 'queryDelSegment'
            } else if (this.isProvinceBatch) {
                module = 'ProvinceBatch'
                method = 'queryDelProvinceBatch'
            } else if (this.isProvinceBatchLine) {
                module = 'ProvinceBatchLine'
                method = 'queryDelProvinceBatchLine'
            } else if (this.isProvinceScoreLine) {
                module = 'ProvinceScoreLine'
                method = 'quryDelProvinceScore'
            } else if (this.isJointCate) {
                module = 'prof'
                method = 'queryDelJointCate'
            } else if (this.isSchoolRank) {
                module = 'SchoolRank'
                method = 'queryDelSchoolRank'
            } else if (this.isProvJoint) {
                module = 'prof'
                method = 'queryDelProvJointCategory'
            } else if (this.isProfLevel) {
                module = 'ProfLevel'
                method = 'queryDeleteProfLevel'
            } else if (this.isProfexam) {
                module = 'Profexamcategory'
                method = 'allDeleteProfexam'
            } else if (this.isEnrollformula) {
                module = 'Enrollformula'
                method = 'allDeleteEnrollformula'
            } else if (this.isSmallscorelimit) {
                module = 'Smallscorelimit'
                method = 'allDeleteSmallscorelimit'
            } else if (this.isSameprof) {
                module = 'Sameprof'
                method = 'allDeleteSameprof'
            } else if (this.isSchTxExamType) {
                module = 'TxExamType'
                method = 'queryDelSchTxExamType'
            } else if (this.isAdmissionSchoolType) {
                module = 'SchoolType'
                method = 'allDeleteSchoolType'
            } else if (this.isCollectionSchoolType) {
                module = 'collectionschool'
                method = 'importDeleteSchool'
            } else if (this.isProvinceScheduleType) {
                module = 'schedule'
                method = 'provinceImportDel'
            } else if (this.isExamScheduleType) {
                module = 'schedule'
                method = 'examImportDel'
            } else if (this.isBatchScheduleType) {
                module = 'schedule'
                method = 'batchImportDel'
            } else if (this.isExceptions) {
                module = 'exceptions'
                method = 'batchDeleteExceptions'
            }
            console.log(JSON.stringify(data))
            this.$confirm('确认删除选中记录吗？', '提示', {
                type: 'warning'
            }).then(() => {
                this.$api[module][method](data).then(res => {
                    if (!res.success) {
                        this.$message({ message: res.message, type: 'error' })
                        return
                    }
                    this.$message({ message: '操作成功', type: 'success' })
                })
            })
        },
        hideDialog() {
            this.$emit('hideDialog', this.filters)
        },
        getBatchList() {
            var param = {
                bizType: this.exportType
            }
            this.$api.ImportBatch.getImportBatchList(param).then(res => {

                this.batchList = res.data
            })
        }
    },
    mounted() {
        this.getBatchList()
    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Component/QueryDelete/index.vue